// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1814":"css/admin-app.6793","4808":"css/app.6793"}[chunkId] + ".css";
};